export enum EnumSubtiposFlexibilidad {
  TakeOrPayBC = 1,
  NegativaBC = 2,
  EstandarBC = 3,
  SwapCB = 4,
  CapCB = 5,
  FloorCB = 6,
  DigitalCB = 7,
  CustomCB = 8,
  NominacionTL = 10,
  EstandarTLInferior = 11,
  EstandarTLSuperior = 12,
  Fijacion = 13,
  FijacionNegativa = 14,
  Compensacion = 15,
  BandaFijacion = 16,
  CompensacionBandaFijacion = 17,
  TLFijacionInferior = 18,
  TLFijacionSuperior = 19,
  TLCheckInferior = 20,
  TLCheckSuperior = 21,
  TLMixInferiorEst = 22,
  TLMixSuperiorEst = 23,
  TLMixInferiorSF = 24,
  TLUmbral = 25,
  TLBonificacion = 26,
  EstandarBD = 27,
  FijacionMixta = 28,
  TLRegularizacionCierreSuperior = 29,
  TLRegularizacionCierreInferior = 30,
  EstandarGdOs = 31,
  PPA = 32,
  ExternaGdOs = 33,
  TLMixInferiorSFV2 = 34,
  ContratoBilateral = 35,
  TLCompBonificacion = 36,
  PPAFinanciero = 38,
  GdODePPA = 39,
  EstandarCierre = 40,
  FijacionPeriodo = 41,
  FijacionLD = 42,
  FijacionCisternas = 43,
  ImporteDirecto = 60
}
